import {MutationTree} from "vuex";
import {WidgetState} from "@/apps/MyStudyChoiceFavoritesWidget/models/store-viewmodel";
import {Config} from "@/apps/MyStudyChoiceFavoritesWidget/models/config-viewmodel";
import {IStudy} from "@/shared/models/api/study-choice-studies-model";

export default <MutationTree<WidgetState>>{
    setLoading(state, loading: boolean) {
        state.loading = loading
    },
    setInnerLoading(state, innerLoading: boolean) {
        state.inner_loading = innerLoading
    },
    setConfig(state, config: Config) {
        state.config = config
    },
    setStudies(state, studies: IStudy[]) {
        state.studies = studies
    },
    setStudySearchModal(state, studySearchModal: boolean) {
        state.study_search_modal = studySearchModal
    },
    removeFavoriteStudyFromFavoriteStudies(state, favoriteStudyId: number) {
        let index = state.studies.map(i => i.id).indexOf(favoriteStudyId)
        let study = state.studies[index]

        study.isFavorite = false
        study.id =0
    },
    addFavoriteStudyToFavoriteStudies(state, payload) {
        let index = state.studies.map(i => i.studyCodeClean).indexOf(payload.studyCode)
        let study = state.studies[index]

        study.isFavorite = true
        study.id = payload.id
    },
    setSearchQuery(state, searchQuery){
        state.search_query = searchQuery
    }
}
